export default "__VITE_ASSET__2T5vk_QR__"